import type { InitiateCheckoutData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class InitiateCheckoutTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: InitiateCheckoutData): void {
    if (!this.factory.isManualEnabled('initiateCheckout')) return;
    this.factory.dispatchManual('INITIATE_CHECKOUT', data);
  }
}
